import type { FernieFaceState } from "~/components/fernie/fernieMarkRules";
import type { StreamStep } from "~/helpers/aiChat/streamSteps";

export type FernieRunOutcome = "success" | "error";

export interface FernieFaceActivity {
	isComposing: boolean;
	isRunActive: boolean;
	steps: StreamStep[];
	outcome: FernieRunOutcome | null;
}

export const hasActiveToolStep = (steps: StreamStep[]): boolean => steps.some((step) => step.status === "active");

export const deriveFernieFaceState = (activity: FernieFaceActivity): FernieFaceState => {
	if (activity.isRunActive) return hasActiveToolStep(activity.steps) ? "working" : "thinking";
	if (activity.outcome === "error") return "straight";
	if (activity.outcome === "success") return "done";
	if (activity.isComposing) return "listening";
	return "rest";
};

export default deriveFernieFaceState;
